import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "row gy-5 g-xl-8 mb-6" }
const _hoisted_2 = { class: "col-12" }
const _hoisted_3 = { class: "card" }
const _hoisted_4 = { class: "card-body" }
const _hoisted_5 = { class: "d-flex flex-column flex-xl-row p-7" }
const _hoisted_6 = { class: "flex-lg-row-fluid me-xl-15 mb-20 mb-xl-0" }
const _hoisted_7 = { class: "mb-0" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("form", {
  class: "form mb-15",
  method: "post",
  action: "#"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "position-relative" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-1 svg-icon-primary position-absolute top-50 translate-middle ms-9" }, [
      /*#__PURE__*/_createElementVNode("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewbox: "0 0 24 24",
        fill: "none"
      }, [
        /*#__PURE__*/_createElementVNode("rect", {
          opacity: "0.5",
          x: "17.0365",
          y: "15.1223",
          width: "8.15546",
          height: "2",
          rx: "1",
          transform: "rotate(45 17.0365 15.1223)",
          fill: "black"
        }),
        /*#__PURE__*/_createElementVNode("path", {
          d: "M11 19C6.55556 19 3 15.4444 3 11C3 6.55556 6.55556 3 11 3C15.4444 3 19 6.55556 19 11C19 15.4444 15.4444 19 11 19ZM11 5C7.53333 5 5 7.53333 5 11C5 14.4667 7.53333 17 11 17C14.4667 17 17 14.4667 17 11C17 7.53333 14.4667 5 11 5Z",
          fill: "black"
        })
      ])
    ]),
    /*#__PURE__*/_createElementVNode("input", {
      class: "form-control form-control-lg form-control-solid ps-14",
      type: "text",
      name: "search",
      value: "",
      placeholder: "Search"
    })
  ])
], -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("h1", { class: "text-dark mb-10" }, "Public Tickets", -1)
const _hoisted_10 = { class: "mb-10" }
const _hoisted_11 = {
  key: 0,
  class: "svg-icon svg-icon-2x me-5 ms-n1 mt-2 svg-icon-success"
}
const _hoisted_12 = {
  key: 1,
  class: "svg-icon svg-icon-2x me-5 ms-n1 mt-2 svg-icon-warning"
}
const _hoisted_13 = { class: "d-flex flex-column" }
const _hoisted_14 = { class: "d-flex align-items-center mb-2" }
const _hoisted_15 = ["href"]
const _hoisted_16 = { class: "badge badge-light my-1" }
const _hoisted_17 = { class: "text-muted fw-bold fs-6" }
const _hoisted_18 = /*#__PURE__*/_createStaticVNode("<ul class=\"pagination\"><li class=\"page-item previous disabled\"><a class=\"page-link\" href=\"#\"><i class=\"previous\"></i></a></li><li class=\"page-item\"><a class=\"page-link\" href=\"#\">1</a></li><li class=\"page-item active\"><a class=\"page-link\" href=\"#\">2</a></li><li class=\"page-item\"><a class=\"page-link\" href=\"#\">3</a></li><li class=\"page-item\"><a class=\"page-link\" href=\"#\">4</a></li><li class=\"page-item\"><a class=\"page-link\" href=\"#\">5</a></li><li class=\"page-item\"><a class=\"page-link\" href=\"#\">6</a></li><li class=\"page-item next\"><a class=\"page-link\" href=\"#\"><i class=\"next\"></i></a></li></ul>", 1)
const _hoisted_19 = { class: "flex-column flex-lg-row-auto w-100 mw-lg-300px mw-xxl-350px" }
const _hoisted_20 = /*#__PURE__*/_createStaticVNode("<div class=\"card-rounded bg-primary bg-opacity-5 p-10 mb-15\"><h2 class=\"text-dark fw-bolder mb-11\">More Channels</h2><div class=\"d-flex align-items-center mb-10\"><i class=\"bi bi-file-earmark-text text-primary fs-1 me-5\"></i><div class=\"d-flex flex-column\"><h5 class=\"text-gray-800 fw-bolder\">Project Briefing</h5><div class=\"fw-bold\"><span class=\"text-muted\">Check out our</span><a class=\"link-primary\" href=\"#\">Support Policy</a></div></div></div><div class=\"d-flex align-items-center mb-10\"><i class=\"bi bi-chat-square-text-fill text-primary fs-1 me-5\"></i><div class=\"d-flex flex-column\"><h5 class=\"text-gray-800 fw-bolder\">More to discuss?</h5><div class=\"fw-bold\"><span class=\"text-muted\">Email us to</span><a class=\"link-primary\" href=\"#\">support@keenthemes.com</a></div></div></div><div class=\"d-flex align-items-center mb-10\"><i class=\"bi bi-twitter text-primary fs-1 me-5\"></i><div class=\"d-flex flex-column\"><h5 class=\"text-gray-800 fw-bolder\">Latest News</h5><div class=\"fw-bold\"><span class=\"text-muted\">Follow us at</span><a class=\"link-primary\" href=\"#\">KeenThemes Twitter</a></div></div></div><div class=\"d-flex align-items-center\"><i class=\"bi bi-github text-primary fs-1 me-5\"></i><div class=\"d-flex flex-column\"><h5 class=\"text-gray-800 fw-bolder\">Github Access</h5><div class=\"fw-bold\"><span class=\"text-muted\">Our github repo</span><a class=\"link-primary\" href=\"#\">KeenThemes Github</a></div></div></div></div>", 1)
const _hoisted_21 = { class: "card-rounded bg-primary bg-opacity-5 p-10 mb-15" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("h1", { class: "fw-bolder text-dark mb-9" }, "Documentation", -1)
const _hoisted_23 = { class: "svg-icon svg-icon-2 ms-n1 me-3" }
const _hoisted_24 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                _hoisted_9,
                _createElementVNode("div", _hoisted_10, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.publicTickets, (ticket, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      class: "d-flex mb-10"
                    }, [
                      (ticket.icon == 'success')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_11, [
                            _createVNode(_component_inline_svg, { src: "/media/icons/duotune/files/fil008.svg" })
                          ]))
                        : (_openBlock(), _createElementBlock("span", _hoisted_12, [
                            _createVNode(_component_inline_svg, { src: "/media/icons/duotune/files/fil005.svg" })
                          ])),
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("div", _hoisted_14, [
                          _createElementVNode("a", {
                            class: "text-dark text-hover-primary fs-4 me-3 fw-bold",
                            href: ticket.link
                          }, _toDisplayString(ticket.title), 9, _hoisted_15),
                          _createElementVNode("span", _hoisted_16, _toDisplayString(ticket.label), 1)
                        ]),
                        _createElementVNode("span", _hoisted_17, _toDisplayString(ticket.description), 1)
                      ])
                    ]))
                  }), 128))
                ]),
                _hoisted_18
              ])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _hoisted_20,
              _createElementVNode("div", _hoisted_21, [
                _hoisted_22,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.documentation, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: "d-flex align-items-center mb-6"
                  }, [
                    _createElementVNode("span", _hoisted_23, [
                      _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr071.svg" })
                    ]),
                    _createElementVNode("a", {
                      class: "fw-bold text-gray-800 text-hover-primary fs-5 m-0",
                      href: item.link
                    }, _toDisplayString(item.label), 9, _hoisted_24)
                  ]))
                }), 128))
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}